import React from 'react'
import { AnimationOnScroll } from 'react-animation-on-scroll'
import { Col, Image, Row, Table } from 'react-bootstrap'
import { useLocation } from 'react-router-dom'

export default function BWRPlywood() {
    let image = useLocation().state.image

    return (
        <div>
            <Row className='mx-0' style={{ marginBottom: '61px' }}>
                <Col md={{ order: 'last' }} className='position-relative w-100 col-md-6 col-12 product-page-image-section mt-5 mt-md-0'>
                    <Image className='product-page-image position-absolute ' src={image} />
                </Col>
                <Col md={{ order: 'first' }} className='col-md-6 col-12'>
                    <AnimationOnScroll duration={2} animateIn="animate__slideInUp">
                        <h3 style={{ fontWeight: '800', color: '#FCCD37', textAlign: 'start' }} className='mb-4'>ABOUT THE<br /> PRODUCT</h3>
                    </AnimationOnScroll>
                    <AnimationOnScroll duration={2} animateIn="animate__slideInUp">
                        <p align='left' style={{ fontSize: '1.3em' }}>
                            BWR plies have higher quality considering the interior grade MR (Moisture
                            Resistant) plywood in terms of its water resistant capacity. As the layers of
                            the ply and the adhesive used are water resistant, the BWR plies last longer
                            and are prone to minimal damage. The structural organisation of the veneer
                            gives them more strength.
                            <br /><br />
                            Let me make something clear to you. Nothing is abstract. Nothing is perfect.
                            What we can do is to manufacture better versions of the initial product.
                            <br /><br />
                            Boiling water-resistant plywood for the kitchen, as the name indicates, is
                            water-resistant. It does not indicate this but is weather-proof as well. This
                            type of plywood can be used for outside use-Garden tables, lawn chairs, etc.
                            This is best preferred by professionals when it comes to exposure to water.
                        </p>
                    </AnimationOnScroll>
                </Col>
            </Row>
            <Row>
                <AnimationOnScroll duration={2} animateIn="animate__slideInUp">
                    <h3 style={{ fontWeight: '800', color: '#FCCD37', textAlign: 'start' }} className='mb-4'>What gives BWR this property?</h3>
                </AnimationOnScroll>
                <AnimationOnScroll duration={2} animateIn="animate__slideInUp">
                    <p align='left' style={{ fontSize: '1.3em' }}>
                        Water-resistant adhesives are used in the layers of the ply. This type of plywood is generally glued with the help of synthetic phenolic
                        resins giving it its unique water-resistant property. Veneer alone is more vulnerable to damage when exposed to water.
                        <br /><br />
                        Specific BWR plywood is resistant to atmospheric moisture and humidity. The structural purpose of these plies is to resist water from
                        damaging their outer core and inner layers. BWR Plywood is also suitable for designing wardrobes. Moisture resistance has a lesser
                        impact compared to the water resistance capacity of the ply.
                        <br /><br />
                        Warping is a matter of concern when it comes to plywood. Three cycles of 08 hour boiling and 16 hours boiling at 65°C proves how
                        resilient BWR is to water and is effective against warping. Thus Boiling water-resistant plywood for the kitchen is one of the best choices
                        we can go for.
                        <br /><br />
                        BWR plywood is also resistant to humidity and atmospheric moisture. These plies are water resistant and suitable for kitchens and places that have
                        minimal water contact.These are also suitable for making designer wardrobes which will add to the aesthetics of your rooms.</p>
                </AnimationOnScroll>
            </Row>
            <Row className='mx-0 justify-content-between' style={{ marginTop: '109px' }}>
                <Col md={2} className='d-flex align-items-center'>
                    <h3 style={{ fontWeight: '800', color: '#FCCD37', textAlign: 'start' }}>Product Specification</h3></Col>
                <Col md={9}>
                    <AnimationOnScroll duration={2} animateIn="animate__slideInUp">
                        <Table responsive>
                            <thead style={{ color: '#FFF' }}>
                                <tr>
                                    <th className='text-start'>TEST</th>
                                    <th className='text-start'>ISI SPECIFIED VALUE</th>
                                    <th className='text-start'>RESULT OBTAINED</th>
                                </tr>
                            </thead>
                            <tbody style={{fontWeight:'500'}}>
                                <tr style={{ color: '#FFF' }}>
                                    <td className='text-start'>Dimension</td>
                                    <td className='text-start'>{`Length +6mm`}<br />
                                        {`Width +3mm`}<br />
                                        {`Thickness ≥ 6mm-±`}<br />
                                        {`5%, < 6mm-±10%`}</td>
                                    <td className='text-start'>Within Limit</td>
                                </tr>
                                <tr style={{ backgroundColor: '#FFC700' }}>
                                    <td className='text-start'>Sp.Gravity</td>
                                    <td className='text-start'></td>
                                    <td className='text-start'>{`>7`}</td>
                                </tr>
                                <tr style={{ color: '#FFF' }}>
                                    <td className='text-start'>Moisture Content</td>
                                    <td className='text-start'>5%-15%</td>
                                    <td className='text-start'>8%</td>
                                </tr>
                                <tr style={{ backgroundColor: '#FFC700' }}>
                                    <td className='text-start'>Resistance to Micro-organism -Adhesion to plywood</td>
                                    <td className='text-start'>Min.Pass Standard</td>
                                    <td className='text-start'>Excellent</td>
                                </tr>
                                <tr style={{ color: '#FFF' }}>
                                    <td className='text-start'>Static Bending Test<br />
                                        Modulus of Elasticity<br />
                                        -Along the grain Avg.+<br />
                                        -Across the grain Avg.+</td>
                                    <td className='text-start'>Min.5000 N/sq.mm<br />
                                        Min.2500 N/sq.mm</td>
                                    <td className='text-start'>6500 N/sq.mm<br />
                                        3000 N/sq.mm</td>
                                </tr>

                                <tr style={{ backgroundColor: '#FFC700' }}>
                                    <td className='text-start'>Modulus of Rupture<br />
                                        -Along the grain Avg.+<br />
                                        -Across the grain Avg.+</td>
                                    <td className='text-start'>Min.40 N/sq.mm<br />
                                        Min.20 N/sq.mm</td>
                                    <td className='text-start'>56 N/sq.mm<br />
                                        30 N/sq.mm</td>
                                </tr>

                                <tr style={{ color: '#FFF' }}>
                                    <td className='text-start'>Resistance to water (3 cycles of 8 hr<br />
                                        Boiling & 16 hr Drying at 65 ℃) -<br />
                                        Adhesion to plywood</td>
                                    <td className='text-start'>Min.Pass Standard</td>
                                    <td className='text-start'>Excellent</td>
                                </tr>
                            </tbody>
                        </Table>
                    </AnimationOnScroll>
                </Col>
            </Row>
        </div>
    )
}
